<template>
  <div class="user-menu">
    <lock-timer :user="user" :lock-url="lockUrl" />
    <router-link
      v-for="(item, index) in items"
      v-if="item.visible"
      :key="`menu-item-${index}`"
      class="user-menu-link"
      :to="userMenuLink(item.url)"
      :target="item.target"
      @click.prevent="linkClick(item.url)"
    >
      <span class="material-icons">{{ item.icon }}</span
      ><span>{{ $i18n.t(item.label) }}</span>
    </router-link>
    <a class="user-menu-link" :href="logoutUrl" @click.prevent="linkClick(logoutUrl)">
      <span class="material-icons">{{'logout'}}</span><span>{{ $i18n.t('logout') }}</span>
    </a>
  </div>
</template>

<script>
import DropdownMenu from './DropdownMenu'
import LockTimer from './LockTimer'
import axios from '../../axiosClient'
import { get, isString } from 'lodash'
import AuthProvider from '../../lib/auth/provider'

/**
 * @class UserMenu
 *
 * @description user menu compoonent
 */
export default {
  name: 'UserMenu',
  components: {
    LockTimer,
    DropdownMenu,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    lockUrl: {
      type: String,
      default: `/logout`,
    },
  },
  data() {
    return {
      logoutUrl: '/logout',
      items: [
        {
          label: 'User profile',
          url: get(this.$CORE, 'env.userProfileUrl'),
          icon: 'badge',
          visible: true,
        },
        {
          label: 'Change password',
          url: get(this.$CORE, 'env.changePasswordUrl'),
          icon: 'password',
          visible: true,
          target: '_self',
        }
      ],
    }
  },
  methods: {
    userMenuLink(url) {
      return url && isString(url) ? url : ''
    },
    async linkClick(url) {

      // User kijelentkeztetése frontenden és backenden
      if (url === this.lockUrl) {
        await axios().get(url).catch(error => { console.error('axios error', error) })
        const authenticator = AuthProvider.getAuthenticator()
        return authenticator.logout()
      }

      const response = await axios().get(url, { params: { redirect: false } })
          .catch(error => { console.error('axios error', error) })
      if (response.error) {
        return this.showNotification({
          title: this.$i18n.t('error_occurred'),
          text: this.$i18n.t('error_occurred: ${buttonName}'),
          params: {
            buttonName: this.buttonName
          },
          type: 'error'
        })
      }
      const redirectUrl = get(response, 'request.responseURL') || url
      const coreParams = await this.$client.execute({
        operationId: 'ExternalParams_dotoParams',
        parameters: {
          url: redirectUrl.replace(/^\//, ''),
        },
      }).catch(error => ({ error }))
      const coreParamsJson = get(coreParams, 'body.CORE', {})
      Object.assign(this.$CORE, coreParamsJson)
      const routeTo = get(coreParamsJson, 'params.route', url)
      this.$router.push({path: routeTo})
    },
  }
}
</script>
<style lang="scss" scoped>
@import 'src/assets/sass/variables';
.user-menu {
  color: $color-text-secondary;
  display: flex;
  flex-direction: column;
}
.user-menu-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 9px 20px;
  gap: 5px;
  color: $white;
  text-decoration: none;
  transition: 0.5s all;
  &:hover {
    font-weight: 600;
    background: $color-primary-hover;
  }
}
</style>
